import React from 'react';
import cn from 'classnames';
import Button from './Button';

type Props = {
  short?: boolean
  className?: string
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  narrow?: boolean
  loading?: boolean
  disabled?: boolean
  to?: string
};

export default function SecondaryButton({
  onClick, short, className, narrow, children, disabled, loading, to,
}: React.PropsWithChildren<Props>) {
  return (
    <Button onClick={onClick} short={short} narrow={narrow} disabled={disabled} loading={loading} to={to}
      className={cn(
        {
          'border ': !disabled,
          'text-blue hover:text-white active:text-white hover:bg-blue focus:outline-none focus:border-blue-focus': !disabled,
          'focus:ring-blue active:bg-blue-press': !disabled,
          'text-white bg-blue opacity-40': disabled,
        },
        className,
      )}
    >{children}
    </Button>
  );
}
